import { Button, Card, CardActions, CardContent, CardMedia, Container, Grid, Typography } from '@mui/material'
import useStyles from '../styles/styles'
import projects from '../data/db'
import Reveal from './Reveal'

const Projects = () => {
  const classes = useStyles()
  return (
    <section id="projects" className={classes.section}>
      <Container className={classes.content}>
        <Reveal>
          <header className={classes.sectionHeader}>
            <Typography className={classes.eyebrow}>02 / Selected work</Typography>
            <Typography component="h2" className={classes.sectionTitle}>Projects</Typography>
          </header>
        </Reveal>
        <Grid container spacing={3} className={classes.cardGrid}>
          {projects.data.map((project, index) => (
            <Grid key={project.id} item xs={12} sm={6}>
              <Reveal delay={index * 70}>
                <Card className={classes.card}>
                  <CardMedia component="img" className={classes.cardMedia} image={project.image} alt={project.alt} loading="lazy" />
                  <CardContent className={classes.cardContent}>
                    <Typography gutterBottom variant="h5" className={classes.cardTitle}>{project.title}</Typography>
                    <Typography variant="body2" className={classes.cardDescription}>{project.description}</Typography>
                  </CardContent>
                  <CardActions className={classes.cardActions}>
                    <Button component="a" href={project.github} target="_blank" rel="noreferrer" className={classes.cardAction}>GitHub ↗</Button>
                    <Button component="a" href={project.url} target="_blank" rel="noreferrer" className={classes.cardAction}>Live site ↗</Button>
                  </CardActions>
                </Card>
              </Reveal>
            </Grid>
          ))}
        </Grid>
      </Container>
    </section>
  )
}

export default Projects
